export const distanceCenterCity: {
    label: string;
    criterias: string[];
    isAvailable: {
        criterias: string[];
    };
}[] = [
    {
        label: 'Au centre',
        criterias: ['305'],
        isAvailable: {
            criterias: ['305']
        }
    },
    {
        label: '200 mètres max',
        criterias: ['305', '299'],
        isAvailable: {
            criterias: ['299']
        }
    },
    {
        label: '500 mètres max',
        criterias: ['305', '299', '300'],
        isAvailable: {
            criterias: ['300']
        }
    },
    {
        label: '1 Km max',
        criterias: ['305', '299', '300', '301'],
        isAvailable: {
            criterias: ['301']
        }
    },
    {
        label: '5 Km max',
        criterias: ['305', '299', '300', '301', '302'],
        isAvailable: {
            criterias: ['302']
        }
    },
    {
        label: '20 Km max',
        criterias: ['305', '299', '300', '301', '302', '303'],
        isAvailable: {
            criterias: ['303']
        }
    },
    {
        label: 'A + de 20 Km  ',
        criterias: ['305', '299', '300', '301', '302', '303', '304'],
        isAvailable: {
            criterias: ['304']
        }
    }
]